import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { Switch } from '@bd/bdcore-named-routes';
import UrlWatcher from '@bd/bdcore-data/build/UrlWatcher';
import NoRouteWrapper from '@bd/bdcore-data/build/NoRouteWrapper';
import AbstractStack from '@bd/bdcore-navigation-stacks/build/AbstractStack';
import DefaultPageComponents from '@bd/bdcore-navigation-stacks/build/DefaultPageComponents';
import ScrollToHash from '@bd/bdcore-navigation-stacks/build/ScrollToHash';

class RegionalSimple extends AbstractStack {
  constructor(props) {
    super(props);

    this.defaultComponents = DefaultPageComponents;
  }

  render() {
    const { Root, ...components } = this.getRawComponents();
    const routes = this.getExtendedRoutes();

    return (
      <Root>
        <Switch>
          {
            routes.map(props => <Route key={props.name} {...props} />)
          }
          <Route name="index" exact path="/" render={UrlWatcher(components.Index)} />
          <Route name="homes" exact path="/rental-properties" render={UrlWatcher(components.HomesList)} />
          <Route name="home-detail" exact path="/rental-properties/:homeStreetAddress" render={UrlWatcher(components.HomeDetail)} />
          <Route name="plans" exact path="/plans" render={UrlWatcher(components.PlansList)} />
          <Route name="plans" exact path="/plans/:communityMarketArea" render={UrlWatcher(components.PlansList)} />
          <Route name="plan-detail" exact path="/plan/:planName" render={UrlWatcher(components.PlanDetail)} />
          <Route name="plan-detail" exact path="/plan/:communityName/:planName" render={UrlWatcher(components.PlanDetail)} />
          <Route name="communities" exact path="/communities" render={UrlWatcher(components.CommunitiesList)} />
          <Route name="communities" exact path="/communities/:communityMarketArea" render={UrlWatcher(components.CommunitiesList)} />
          <Route name="community-detail" exact path="/communities/:communityMarketArea/:communityName" render={UrlWatcher(components.CommunityDetail)} />
          <Route name="blog" exact path="/blog" render={UrlWatcher(components.BlogpostList)} />
          <Route name="blog-category" exact path="/blog/category-:blogCategory" render={UrlWatcher(components.BlogpostList)} />
          <Route name="blog-tag" exact path="/blog/tag-:blogTag" render={UrlWatcher(components.BlogpostList)} />
          <Route name="blogpost-detail" exact path="/blog/:blogpostTitle" render={UrlWatcher(components.BlogpostDetail)} />
          <Route exact render={UrlWatcher(NoRouteWrapper(components.NoRoute))} />
        </Switch>
        <ScrollToHash />
      </Root>
    );
  }
}

RegionalSimple.propTypes = {
  ...AbstractStack.propTypes,
  store: PropTypes.object,
};

RegionalSimple.defaultProps = {
  ...AbstractStack.defaultProps,
  store: undefined,
};

export default RegionalSimple;



// WEBPACK FOOTER //
// ./src/RegionalRental.js